<template>
  <div class="sale-contact-card">
    <div class="card__header card-padding-top card-padding-x">
      <span class="card__header--topic">Sale/NTDC Contact</span>
      <div
        v-if="isShowInitialContactHeader"
        class="sale-contact-initial-header mt-2"
      >
        Sale/NTDC Contact <span class="text--danger">*</span>
      </div>
      <div
        v-for="(sale, index) in currentSaleContactList"
        :key="index"
        class="sale-contact-container"
      >
        <div class="sale-contact-header my-1">Sale/NTDC Contact</div>
        <div class="d-block d-sm-flex contact-point-wrapper custom-max-width">
          <div class="icon-container d-flex">
            <div
              v-if="!isContractInDeletedStatus && hasEditPermission"
              class="icon-wrapper"
              @click="onClickEditContactDetail(sale, index)"
            >
              <feather-icon
                class="icon-size-20px"
                icon="EditIcon"
              ></feather-icon>
            </div>
            <div
              v-if="!isContractInDeletedStatus && hasEditPermission"
              class="ml-1 icon-wrapper"
              @click="onClickDeleteContactDetail(sale, index)"
            >
              <feather-icon
                class="icon-size-20px"
                icon="Trash2Icon"
              ></feather-icon>
            </div>
          </div>
          <div class="d-flex justify-content-center justify-content-sm-start">
            <div class="img-wrapper my-1 my-sm-0">
              <b-img
                v-if="sale.image"
                :src="sale.image"
                rounded
                class="profile-picture"
              />
              <div v-else class="no-image-container">
                <b-img v-bind="defaultPicture" rounded blank-color="#efefef" />
                <span class="no-image-text font-size-12">No image</span>
              </div>
            </div>
          </div>
          <div class="information-wrapper ml-0 ml-sm-2">
            <span class="d-block text-semibold-primary font-size-16">
              {{ sale.name.contactPointName }}
            </span>
            <div class="d-flex align-items-center custom-margin-top-6">
              <feather-icon icon="MailIcon" size="12" />
              <span class="font-size-12 pl-1"> {{ sale.email.email }} </span>
            </div>
            <div class="d-flex align-items-center custom-margin-top-6">
              <feather-icon icon="PhoneIcon" size="12" />
              <span class="font-size-12 pl-1"> {{ sale.phone.phone }} </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isShowButton && !isContractInDeletedStatus && hasEditPermission"
        class="button-wrapper"
      >
        <div class="button-dash box-dashed" @click="onClickSelectSaleContact">
          <feather-icon
            class="icon-size-24px text-primary"
            icon="PlusCircleIcon"
          ></feather-icon>
          <label class="button--text">Select Sale Contact</label>
        </div>
      </div>
      <div
        v-if="isErrorNotSelectSaleContact"
        class="mt-2 d-flex align-items-center"
      >
        <feather-icon
          class="icon-size-20px text-danger"
          icon="AlertCircleIcon"
        ></feather-icon>
        <span class="text-danger custom-error-message"
          >Please Select Sale/NTDC Contact</span
        >
      </div>
    </div>

    <!-- start modal section -->
    <!-- start modal delete -->
    <molecule-modal-dialog
      modalId="modal-confirm-delete-sale-contact"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete ?"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmDeleteFromModal"
      @clickButtonRight="onClickCancelDeleteFromModal"
      @clickIconClose="onClickCancelDeleteFromModal"
    >
      <template #body>
        <div class="modal-confirm-delete-sale-contact-body">
          <label class="text-center text--subtitle-modal">
            Sale/NTDC Contact: {{ targetSaleContact.name.contactPointName }}
            <br />
            will be deleted from this contract
          </label>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal delete -->

    <!-- start modal select -->
    <molecule-modal-dialog
      modalId="modal-select-sale-contact"
      buttonTextLeft="Select"
      buttonColorLeft="primary"
      textTitle="Select Sale Contact"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmSelectFromModal"
      @clickButtonRight="onClickCancelSelectFromModal"
      @clickIconClose="onClickCancelSelectFromModal"
    >
      <template #body>
        <!-- Temporary Close this button util fix location option by site later -->
        <!-- <div
          v-if="hasCreateContactPointPermission"
          class="add-new-contact-button-container mt-2"
        >
          <atom-button
            buttonId="add-new-contact-button"
            buttonStyle="border"
            @click="onClickCreateNewContactFromModal"
          >
            <span class="button-text">Create New Contact</span>
          </atom-button>
        </div> -->
        <div class="select-name-container w-80 mt-1">
          <atom-select
            v-model="targetSaleContact.name"
            title="Full Name"
            placeholder="Select Customer"
            label="contactPointName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectFullName"
            :errorMessage="errorMessageAtSelector"
            :option="saleOption"
          ></atom-select>
        </div>
        <div class="select-email-container w-80 mt-1">
          <atom-select
            v-model="targetSaleContact.email"
            title="Email"
            placeholder="Select Email"
            label="email"
            :isAsterisk="true"
            :isDisable="!targetSaleContact.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectEmail"
            :errorMessage="errorMessageAtSelector"
            :option="emailOption"
          ></atom-select>
        </div>
        <div class="select-phone-container w-80 mt-1 mb-2">
          <atom-select
            v-model="targetSaleContact.phone"
            title="Phone Number"
            placeholder="Select Phone Number"
            label="phone"
            :isAsterisk="true"
            :isDisable="!targetSaleContact.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectPhoneNumber"
            :errorMessage="errorMessageAtSelector"
            :option="phoneOption"
          ></atom-select>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal select -->

    <!-- start modal edit -->
    <molecule-modal-dialog
      modalId="modal-edit-sale-contact"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      textTitle="Edit Sale Contact"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="!isTargetSaleContactChange"
      @clickButtonLeft="onClickConfirmEditFromModal"
      @clickButtonRight="onClickCancelEditFromModal"
      @clickIconClose="onClickCancelEditFromModal"
    >
      <template #body>
        <!-- Temporary Close this button util fix location option by site later -->
        <!-- <div class="add-new-contact-button-container mt-2">
          <atom-button
            buttonId="add-new-contact-button"
            buttonStyle="border"
            @click="onClickCreateNewContactFromModal"
          >
            <span class="button-text">Create New Contact</span>
          </atom-button>
        </div> -->
        <div class="select-name-container w-80 mt-1">
          <atom-select
            v-model="targetSaleContact.name"
            title="Full Name"
            placeholder="Select Customer"
            label="contactPointName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectFullName"
            :errorMessage="errorMessageAtSelector"
            :option="saleOption"
          ></atom-select>
        </div>
        <div class="select-email-container w-80 mt-1">
          <atom-select
            v-model="targetSaleContact.email"
            title="Email"
            placeholder="Select Email"
            label="email"
            :isAsterisk="true"
            :isDisable="!targetSaleContact.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectEmail"
            :errorMessage="errorMessageAtSelector"
            :option="emailOption"
          ></atom-select>
        </div>
        <div class="select-phone-container w-80 mt-1 mb-2">
          <atom-select
            v-model="targetSaleContact.phone"
            title="Phone Number"
            placeholder="Select Phone Number"
            label="phone"
            :isAsterisk="true"
            :isDisable="!targetSaleContact.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectPhoneNumber"
            :errorMessage="errorMessageAtSelector"
            :option="phoneOption"
          ></atom-select>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit -->

    <!-- start modal create new contact -->
    <molecule-modal-dialog
      modalId="modal-create-new-sale-contact"
      buttonTextLeft="Create"
      buttonColorLeft="primary"
      textTitle="Create New Sale Contact"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmCreateNewSaleContactFromModal"
      @clickButtonRight="onClickCancelCreateNewSaleFromModal"
      @clickIconClose="onClickCancelCreateNewSaleFromModal"
    >
      <template #body>
        <div
          name="modal-create-new-sale-contact"
          class="modal-content-container"
        >
          <div class="row mt-2">
            <div class="col-12 flex-row">
              <div class="profile-picture-container">
                <b-img
                  v-if="image"
                  :src="imageSrc"
                  rounded
                  class="profile-picture"
                />
                <div v-else class="no-image-container">
                  <b-img
                    v-bind="defaultPicture"
                    rounded
                    blank-color="#efefef"
                  />
                  <span class="no-image-text font-size-12">No image</span>
                </div>
              </div>
              <atom-file-input
                v-model="image"
                title="Select Profile Picture"
                :isOnlyImage="true"
                class="mt-1 mb-1 mb-md-0"
              ></atom-file-input>
            </div>
            <div class="col-12 mt-2 mb-1 mb-md-0 flex-row align-self-end">
              <span class="text-topic--medium">Personal Data</span>
              <div class="row mt-1">
                <div class="col-12 col-md-6">
                  <atom-input
                    v-model="newSaleContact.firstName"
                    title="First Name"
                    placeholder="First Name"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactFirstName"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
                <div class="col-12 col-md-6 mt-1 mt-md-0">
                  <atom-input
                    v-model="newSaleContact.lastName"
                    title="Last Name"
                    placeholder="Last Name"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactLastName"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 col-md-6">
                  <atom-select
                    v-model="newSaleContact.idType"
                    title="Identification Type"
                    placeholder="Select Type"
                    label="name"
                    :isAsterisk="true"
                    :isClearable="false"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :isError="isErrorAtNewContactIdType"
                    :errorMessage="errorMessageAtSelector"
                    :option="idTypeOption"
                  ></atom-select>
                </div>
                <div class="col-12 col-md-6 mt-1 mt-md-0">
                  <atom-input
                    v-model="newSaleContact.idOrPassportNumber"
                    title="ID/Passport Number"
                    placeholder="ID/Passport Number"
                    :isDisable="!newSaleContact.idType"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactContactIdOrPassportNumber"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-1 mt-md-3 mb-2">
            <div class="col-12 col-md-6 mb-1 mb-md-0 flex-row">
              <span class="text-topic--medium">Email List</span>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.email.primary.email"
                  title="Email 1"
                  placeholder="Email"
                  :isAsterisk="true"
                  :isError="isErrorAtNewContactEmailPrimary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.email.secondary.email"
                  title="Email 2"
                  placeholder="Email"
                  :isError="isErrorAtNewContactEmailSecondary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.email.third.email"
                  title="Email 3"
                  placeholder="Email"
                  :isError="isErrorAtNewContactEmailThird"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0 flex-row">
              <span class="text-topic--medium">Phone Number List</span>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.phone.primary.phone"
                  title="Phone Number 1"
                  placeholder="Phone Number"
                  :isAsterisk="true"
                  :isError="isErrorAtNewContactPhoneNumberPrimary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.phone.secondary.phone"
                  title="Phone Number 2"
                  placeholder="Phone Number"
                  :isError="isErrorAtNewContactPhoneNumberSecondary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newSaleContact.phone.third.phone"
                  title="Phone Number 3"
                  placeholder="Phone Number"
                  :isError="isErrorAtNewContactPhoneNumberThird"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
            </div>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal create new contact -->

    <!-- end modal section -->
  </div>
</template>

<script>
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

import { BImg } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomFileInput from "@/components/atoms/AtomFileInput.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidators from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "MoleculeSaleContact",
  components: {
    AtomButton,
    AtomFileInput,
    AtomInput,
    AtomSelect,
    BImg,
    MoleculeModalDialog,
  },
  props: {
    contractStatus: {
      type: String,
      required: false,
      default: null,
    },
    basedSaleContactList: {
      type: Object,
      required: false,
      default: () => {},
    },
    saleOption: {
      type: Array,
      required: true,
    },
    selectedSaleContactId: {
      type: String,
      required: false,
      default: null,
    },
    selectedSaleContactDetail: {
      type: Object,
      required: false,
      default: null,
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [mixinsValidators, mixinsObjectHelper, mixinsUser],
  emits: [
    "onUpdateSaleContact",
    "onUpdateErrorInMoleculeSaleContact",
    "onRequestCreateNewSaleContact",
  ],
  data() {
    return {
      modalId: null,
      previousSelectSaleModalId: null,
      defaultPicture: { blank: true, width: 150, height: 150 },
      image: null,
      imageSrc: null,
      isValidateSelectContactTrigger: false,
      isValidateNewContactTrigger: false,
      errorMessageAtInput: "Please enter valid data",
      errorMessageAtSelector: "Please select data",
      currentSaleContactList: [],
      idTypeOption: ["ID", "Passport Number"],
      emailOption: [],
      phoneOption: [],
      newSaleContact: {
        id: "",
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: null,
        idOrPassportNumber: "",
        role: null,
        email: {
          primary: { contactPointEmailId: null, email: "" },
          secondary: { contactPointEmailId: null, email: "" },
          third: { contactPointEmailId: null, email: "" },
        },
        phone: {
          primary: { contactPointPhoneId: null, phone: "" },
          secondary: { contactPointPhoneId: null, phone: "" },
          third: { contactPointPhoneId: null, phone: "" },
        },
      },
      targetSaleContact: {
        name: "",
        email: "",
        phone: "",
        image: "",
      },
      originTargetSaleContact: null,
      currentSaleImage: "",
    }
  },
  computed: {
    contractId() {
      return this.$route?.params?.id
    },
    hasCreateContactPointPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE)
    },
    isContractInDeletedStatus() {
      return this.contractStatus?.toLowerCase() === "deleted"
    },
    isShowInitialContactHeader() {
      return this.currentSaleContactList.length === 0
    },
    isShowButton() {
      return this.currentSaleContactList.length < 1
    },
    isDefaultTargetValue() {
      return this.isEmptyString(this.targetSaleContact.name)
    },
    isErrorAtSelectFullName() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetSaleContact.name)
        : false
    },
    isErrorAtSelectEmail() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetSaleContact.email)
        : false
    },
    isErrorAtSelectPhoneNumber() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetSaleContact.phone)
        : false
    },
    isErrorAtNewContactFirstName() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newSaleContact.firstName)
        : false
    },
    isErrorAtNewContactLastName() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newSaleContact.lastName)
        : false
    },
    isErrorAtNewContactIdType() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyObject(this.newSaleContact.idType)
        : false
    },
    isErrorAtNewContactContactIdOrPassportNumber() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newSaleContact.idOrPassportNumber)
        : false
    },
    isErrorAtNewContactEmailPrimary() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newSaleContact.email.primary.email) ||
            this.isInvalidEmail(this.newSaleContact.email.primary.email)
        : false
    },
    isErrorAtNewContactEmailSecondary() {
      return this.isValidateNewContactTrigger
        ? this.isInvalidEmail(this.newSaleContact.email.secondary.email) &&
            !this.isEmptyString(this.newSaleContact.email.secondary.email)
        : false
    },
    isErrorAtNewContactEmailThird() {
      return this.isValidateNewContactTrigger
        ? this.isInvalidEmail(this.newSaleContact.email.third.email) &&
            !this.isEmptyString(this.newSaleContact.email.third.email)
        : false
    },
    isErrorAtNewContactPhoneNumberPrimary() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newSaleContact.phone.primary.phone)
        : // || this.isInvalidPhoneNumber(this.newSaleContact.phone.primary.phone)
          false
    },
    isErrorAtNewContactPhoneNumberSecondary() {
      return false
      // return this.isValidateNewContactTrigger
      //   ? this.isInvalidPhoneNumber(
      //       this.newSaleContact.phone.secondary.phone
      //     ) && !this.isEmptyString(this.newSaleContact.phone.secondary.phone)
      //   : false
    },
    isErrorAtNewContactPhoneNumberThird() {
      return false
      // return this.isValidateNewContactTrigger
      //   ? this.isInvalidPhoneNumber(this.newSaleContact.phone.third.phone) &&
      //       !this.isEmptyString(this.newSaleContact.phone.third.phone)
      //   : false
    },
    isErrorOccurAtSelectSaleContact() {
      return (
        this.isErrorAtSelectFullName ||
        this.isErrorAtSelectEmail ||
        this.isErrorAtSelectPhoneNumber
      )
    },
    isErrorOccurAtCreateNewSaleContact() {
      return (
        this.isErrorAtNewContactFirstName ||
        this.isErrorAtNewContactLastName ||
        this.isErrorAtNewContactIdType ||
        this.isErrorAtNewContactContactIdOrPassportNumber ||
        this.isErrorAtNewContactEmailPrimary ||
        this.isErrorAtNewContactEmailSecondary ||
        this.isErrorAtNewContactEmailThird ||
        this.isErrorAtNewContactPhoneNumberPrimary ||
        this.isErrorAtNewContactPhoneNumberSecondary ||
        this.isErrorAtNewContactPhoneNumberThird
      )
    },
    isTargetSaleContactChange() {
      return this.compareIsChangeObject(
        this.originTargetSaleContact,
        this.targetSaleContact
      )
    },
    isErrorNotSelectSaleContact() {
      return this.isValidateTrigger
        ? this.currentSaleContactList.length === 0
        : false
    },
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value
              this.$emit("onUpdateSaleProfilePicture", this.image)
            })
            .catch(() => {
              this.imageSrc = null
            })
        } else {
          this.imageSrc = null
        }
      }
    },
    basedSaleContactList: {
      deep: true,
      handler() {
        if (this.basedSaleContactList) {
          const arrayOfSaleContact = [this.basedSaleContactList]
          this.currentSaleContactList =
            this.getDecoratedBaseContactData(arrayOfSaleContact)
        }
      },
    },
    saleOption: {
      deep: true,
      handler() {
        if (this.selectedSaleContactId) {
          this.targetSaleContact.name = this.saleOption.find(
            (saleContact) =>
              saleContact.contactPointId === this.selectedSaleContactId
          )
        }
      },
    },
    selectedSaleContactDetail: {
      deep: true,
      handler() {
        if (this.selectedSaleContactDetail) {
          this.emailOption = this.selectedSaleContactDetail.emails
          this.phoneOption = this.selectedSaleContactDetail.phones
          this.currentSaleImage = this.selectedSaleContactDetail.image
        }
        if (this.selectedSaleContactId) {
          this.targetSaleContact.email = this.emailOption[0]
          this.targetSaleContact.phone = this.phoneOption[0]
          this.$emit("onClearSelectedSaleContactId")
        }
      },
    },
    "targetSaleContact.name": {
      deep: true,
      handler(newValue, oldValue) {
        if (this.targetSaleContact.name) {
          const selectedSaleContact = { ...this.targetSaleContact.name }
          this.$emit("onSelectSaleContact", selectedSaleContact)
        }
        if (oldValue && newValue !== oldValue) {
          this.targetSaleContact.email = null
          this.targetSaleContact.phone = null
        }
      },
    },
    isErrorNotSelectSaleContact: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit(
          "onUpdateErrorAtMoleculeSaleContact",
          this.isErrorNotSelectSaleContact
        )
      },
    },
  },
  methods: {
    getDecoratedBaseContactData(basedSaleContactList) {
      return basedSaleContactList.length
        ? basedSaleContactList.map((item) => {
            return {
              name: {
                contactPointName:
                  item.contactFirstname + " " + item.contactLastname,
                contactPointId: item.contactId,
              },
              image: item.contactImage,
              email: {
                email: item.contactEmail,
                contactPointEmailId: item.contactEmailId,
              },
              phone: {
                phone: item.contactPhone,
                contactPointPhoneId: item.contactPhoneId,
              },
            }
          })
        : []
    },
    setDefaultTargetValue() {
      this.targetSaleContact = {
        name: "",
        email: "",
        phone: "",
        image: "",
      }
    },
    setDefaultNewSaleContact() {
      this.newSaleContact = {
        id: "",
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: null,
        idOrPassportNumber: "",
        role: null,
        email: {
          primary: "",
          secondary: "",
          third: "",
        },
        phone: {
          primary: "",
          secondary: "",
          third: "",
        },
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    editContactPoint() {
      const targetIndex = this.targetSaleContact.index
      const editedContactPointValue = {
        name: this.targetSaleContact.name,
        email: this.targetSaleContact.email,
        phone: this.targetSaleContact.phone,
        image: this.currentSaleImage,
      }
      this.$set(
        this.currentSaleContactList,
        targetIndex,
        editedContactPointValue
      )
      this.closeModal()
      this.$emit("onUpdateCurrentSaleList", this.currentSaleContactList)
    },
    deleteSaleContact() {
      const targetIndex = this.targetSaleContact.index
      this.currentSaleContactList.splice(targetIndex, 1)
      this.$emit("onUpdateCurrentSaleList", this.currentSaleContactList)
    },
    onClickSelectSaleContact() {
      this.setDefaultTargetValue()
      this.modalId = "modal-select-sale-contact"
      this.$bvModal.show(this.modalId)
    },
    onClickEditContactDetail(saleContact, index) {
      this.targetSaleContact = { ...saleContact, index: index }
      this.originTargetSaleContact = JSON.parse(
        JSON.stringify(this.targetSaleContact)
      )
      this.modalId = "modal-edit-sale-contact"
      this.$bvModal.show(this.modalId)
    },
    onClickDeleteContactDetail(saleContact, index) {
      this.targetSaleContact = { ...saleContact, index: index }
      this.modalId = "modal-confirm-delete-sale-contact"
      this.$bvModal.show(this.modalId)
    },
    onClickCreateNewContactFromModal() {
      this.previousSelectSaleModalId = this.modalId
      this.closeModal()
      this.modalId = "modal-create-new-sale-contact"
      this.$bvModal.show(this.modalId)
    },
    onClickConfirmDeleteFromModal() {
      this.deleteSaleContact()
      this.setDefaultTargetValue()
      this.closeModal()
    },
    onClickCancelDeleteFromModal() {
      this.setDefaultTargetValue()
    },
    onClickConfirmCreateNewSaleContactFromModal() {
      this.isValidateNewContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtCreateNewSaleContact) {
          const newSaleContactDetail = { ...this.newSaleContact }
          this.$emit("onRequestCreateNewSaleContact", newSaleContactDetail)
          this.isValidateNewContactTrigger = false
          this.setDefaultNewSaleContact()
          this.closeModal()
          this.modalId = this.previousSelectSaleModalId
          this.$bvModal.show(this.modalId)
        }
      })
    },
    onClickCancelCreateNewSaleFromModal() {
      this.modalId = this.previousSelectSaleModalId
      this.$bvModal.show(this.modalId)
      this.setDefaultNewSaleContact()
    },
    onClickConfirmSelectFromModal() {
      this.isValidateSelectContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtSelectSaleContact) {
          this.currentSaleContactList.push({
            ...this.targetSaleContact,
            image: this.currentSaleImage,
          })
          this.$emit("onUpdateCurrentSaleList", this.currentSaleContactList)
          this.closeModal()
          this.isValidateSelectContactTrigger = false
          this.setDefaultTargetValue()
        }
      })
    },
    onClickCancelSelectFromModal() {
      this.setDefaultTargetValue()
    },
    onClickConfirmEditFromModal() {
      this.isValidateSelectContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtSelectSaleContact) {
          this.editContactPoint()
          this.$emit("onUpdateCurrentSaleList", this.currentSaleContactList)
          this.isValidateSelectContactTrigger = false
        }
      })
    },
    onClickCancelEditFromModal() {
      this.setDefaultTargetValue()
    },
  },
}
</script>

<style lang="scss" scoped>
.card__header {
  padding: 21px;
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.button-dash {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-wrapper,
.sale-contact-detail {
  width: 100%;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.text--danger {
  color: #ea5455;
}

.text-topic--medium {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #5e5873;
}

.text--subtitle-modal {
  font-size: 14px;
}

.custom-error-message {
  margin-left: 8px;
  line-height: 1.5;
  font-size: 12px;
}

.sale-contact-initial-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}

.sale-contact-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #b9b9c3;
}

.sale-contact-detail {
  margin-top: 9px;
}

.sale-contact-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #82868b;
}

.contact-email-and-phone {
  margin-top: 9px;
  width: 100%;
}

.icon-wrapper:hover {
  cursor: pointer;
}

.add-new-contact-button-container {
  display: flex;
  align-self: flex-end;
  padding-right: 2rem;
}

div[name="modal-create-new-sale-contact"].modal-content-container {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.profile-picture-container {
  display: flex;
  justify-content: center;
  height: 150px;
}

.profile-picture {
  max-width: 150px;
  max-height: 150px;
  object-fit: contain;
}

.custom-margin-top-6 {
  margin-top: 6px;
}

.list__ul {
  padding-left: 16px;
}

.access-card {
  line-height: 24px;
}

.contact-point-wrapper {
  position: relative;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebe9f1;
}

.icon-container {
  position: absolute;
  right: 0;
  top: -36px;
}

.custom-max-width {
  max-width: 550px;
}

.img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  border-radius: 0.357rem;
  background-color: #efefef;
}

.no-image-container {
  position: relative;
  .no-image-text {
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .icon-container {
    position: absolute;
    right: 0;
    top: 0;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .button-wrapper,
  .sale-contact-detail {
    width: 550px;
  }
  .contact-email-and-phone {
    width: 80%;
  }
  .add-new-contact-button-container {
    padding-right: 3.25rem;
  }
  div[name="modal-create-new-sale-contact"].modal-content-container {
    height: 600px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}
</style>
